import React, { useState } from 'react';
import { BRAND } from '@/config/site';

/**
 * Logo — S.M.I. brand mark.
 * Tries to render the founder-uploaded logo at BRAND.logoImage (default /logo.svg).
 * If the image fails to load (or the file isn't present yet), it falls back to
 * a code-built placeholder: a shield with a check + fingerprint scan lines,
 * rendered in chrome/silver on black with an electric-blue accent.
 */
export default function Logo({ size = 40, className = '', title = BRAND.short }) {
    const [imgFailed, setImgFailed] = useState(false);

    if (BRAND.logoImage && !imgFailed) {
        return (
            <img
                src={BRAND.logoImage}
                alt={`${BRAND.name} logo`}
                width={size}
                height={size}
                className={className}
                onError={() => setImgFailed(true)}
                style={{ objectFit: 'contain' }}
            />
        );
    }

    return (
        <svg
            viewBox="0 0 64 64"
            width={size}
            height={size}
            className={className}
            role="img"
            aria-label={title}
        >
            <defs>
                <linearGradient id="smi-steel" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0%" stopColor="#F4F6FB" />
                    <stop offset="45%" stopColor="#B6BEC9" />
                    <stop offset="100%" stopColor="#4A5568" />
                </linearGradient>
                <radialGradient id="smi-glow" cx="50%" cy="45%" r="55%">
                    <stop offset="0%" stopColor="#00F0FF" stopOpacity="0.7" />
                    <stop offset="100%" stopColor="#050508" stopOpacity="0" />
                </radialGradient>
            </defs>
            <rect width="64" height="64" rx="12" fill="#050508" />
            <circle cx="32" cy="30" r="26" fill="url(#smi-glow)" />
            {/* Fingerprint arc lines */}
            <g fill="none" stroke="#00F0FF" strokeOpacity="0.55" strokeWidth="1.1">
                <path d="M14 30 Q32 6 50 30" />
                <path d="M18 34 Q32 14 46 34" />
                <path d="M22 38 Q32 22 42 38" />
            </g>
            {/* Shield */}
            <path
                d="M32 12 L48 18 L48 34 Q48 46 32 52 Q16 46 16 34 L16 18 Z"
                fill="url(#smi-steel)"
                stroke="#0A0A12"
                strokeWidth="1"
            />
            {/* Verification check */}
            <path
                d="M23 32 L30 39 L43 24"
                stroke="#00F0FF"
                strokeWidth="3"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
